import { api } from "./backend";
import { listado } from "./listado";
import * as TipoCuota from "@/enums/TipoCuota";
import { normalizarModulo } from "./modulos";

export function crearOfertaBase() {
  return {
    id: null,
    clienteId: null,
    ofertaActivaId: null,
    creadoPor: null,
    creadoEl: null,
    unidadNegocioId: null,
  };
}

export function crearOferta() {
  return {
    id: null,
    ofertaBaseId: null,
    usuarioId: null,
    campaniaId: null,
    descripcion: "",
    codigo: null,
    fecha: new Date(),
    fechaRelevante: null,
    numeroVersion: 1,
    paisId: null,
    divisaId: null,
    planId: null,
    origenOfertaId: null,
    complejidadProyectoId: Number(process.env.VUE_APP_COMPLEJIDAD_POR_DEFECTO_ID),
    contacto: "",
    cargoContacto: "",
    numeroUsuarios: 0,
    borrador: 1,
    visada: 0,
    entregada: 0,
    ganada: 0,
    perdida: 0,
    revisadoPor: null,
    creadoPor: null,
    creadoEl: null,
    origen: null,
    pipedrive: null,
    tipoVenta: Number(process.env.VUE_APP_TIPO_VENTA_POR_DEFECTO),
    fechaFirmaContrato: null,
    duracionContratoId: null,
    caducada: null,
    ofertaDescuentoFirma: crearDescuentoFirma(),
    tarifaId: null,
    tipoCuota: TipoCuota.ANUAL,
    tipoProyecto: Number(process.env.VUE_APP_TIPO_PROYECTO_POR_DEFECTO),
    formaPagoSuscripcionId: Number(process.env.VUE_APP_FORMA_PAGO_POR_DEFECTO_ID),
    formaPagoImplementacionId: Number(process.env.VUE_APP_FORMA_PAGO_POR_DEFECTO_ID),
    observacionesFormaPago: "",
    tipoDescuentoSuscripcion: 0,
    tipoDescuentoCuotaAnual: 0,
    tipoDescuentoServicios: 0,
    tipoDescuentoImplementacion: 0,
    tipoDescuentoPorFirmaEnPlazo: 0,
    esPartner: false,
    importeSuscripcion: 0,
    importeImplementacion: 0,
    importeCuotaAnual: 0,
    importeServicios: 0,
    importeDescuentoSuscripcion: 0,
    importeDescuentoImplementacion: 0,
    importeDescuentoCuotaAnual: 0,
    importeDescuentoServicios: 0,
    importeDescuentoPorFirmaEnPlazo: 0,
    cuotaMensualEstimada: 0,
    importeTotalEstimado: 0,
    importeTotalInicial: 0,
    totalHorasConsultoria: 0,
    totalHorasCapacitacion: 0,
    valorada: false,
    valoradaEl: "",
    // Columnas calculadas de oferta
    tieneDescuentos: false,
    tieneDescuentosVisibles: false,
    tienePagoMensual: false,
    totalCuotaMensual: 0,
    totalCuotaAnual: 0,
    totalServicios: 0,
    totalImplementacion: 0,
    totalSuscripcion: 0,
    tipoDescuentoFinalCuota: 0,
  };
}

export function crearOfertaContenido() {
  return {
    ofertaId: null,
    texto: "",
    necesidades: "",
    tablaNecesidades: "",
    resumenEjecutivo: "",
    aclaraciones: "",
    anexo: "",
    logosClientes: "",
    beneficios: "",
    usuarios: "",
    planDeSoporte: "",
    requisitosMinimos: "",
  };
}

export function crearOfertaContrato() {
  return {
    ofertaId: null,
    textoContrato: "",
    textoBorrador: "",
  };
}

export function crearDescuentoFirma() {
  return {
    id: null,
    ofertaId: null,
    campaniaId: null,
    plazoDescuentoCampaniaId: null,
    dias: 0,
    descuento: 0,
  };
}

export function normalizarOferta(data) {
  data.costeDeImplementacionCubierto = Boolean(data.costeDeImplementacionCubierto);
  data.precioModificado = Boolean(data.precioModificado);

  return data;
}

export function normalizarOfertaBase(data) {
  if (data.unidadNegocioId == 0) {
    data.unidadNegocioId = null;
  }

  return data;
}

export function normalizarOfertaModulo(data) {
  data.cubreCosteDeImplementacion = Boolean(data.cubreCosteDeImplementacion);
  data.precioModificado = Boolean(data.precioModificado);

  return data;
}

export function listar(params) {
  return listado("ofertas/listar", params);
}

export function listarVersionesDe(de, params) {
  return listado("ofertas/listar", params, {
    versionesDe: de,
  });
}

export async function cargar(id) {
  const response = await api.get("ofertas/cargar&ofertaId=" + id);
  return response.data;
}

/**
 * Carga una oferta:
 * Recibe:
 *     data.ofertaBase
 *     data.oferta
 *     data.ofertaContenido
 *     data.ofertaModulos
 *     data.cliente
 */
export async function cargarCompleta(id) {
  const response = await api.get("ofertas/cargarCompleta&ofertaId=" + id);
  const data = response.data;

  data.oferta = normalizarOferta(data.oferta);
  data.ofertaBase = normalizarOfertaBase(data.ofertaBase);
  Object.values(data.modulos).forEach(normalizarModulo);
  data.ofertaModulos.forEach(normalizarOfertaModulo);
  data.esPartner = Boolean(data.esPartner);

  return data;
}

export function moduloParaEstaOferta(params) {
  return api.post("ofertas/moduloParaEstaOferta", params).then((response) => {
    const modulo = response.data.modulo;
    const moduloContenido = response.data.moduloContenido;
    const ofertaModulo = response.data.ofertaModulo;

    return {
      modulo: modulo,
      ofertaModulo: ofertaModulo,
      moduloContenido,
    };
  });
}

export async function insertar({ ofertaBase, oferta, ofertaModulosAgregados }) {
  const r = await api.post("ofertas/insertar", {
    ofertaBase,
    oferta,
    ofertaModulosAgregados,
  });
  return r.data;
}

export async function actualizar({
  ofertaBase,
  oferta,
  ofertaModulosAgregados,
  ofertaModulosActualizados,
  ofertaModulosEliminados,
}) {
  const r = await api.post("ofertas/actualizar", {
    ofertaBase,
    oferta,
    ofertaModulosAgregados,
    ofertaModulosActualizados,
    ofertaModulosEliminados,
  });
  return r.data;
}

export async function cargarContenidoVersion(id) {
  const r = await api.get("ofertas/cargarContenidoVersion&ofertaId=" + id);
  return r.data.ofertaContenido;
}

export async function guardarContenidoVersion(ofertaContenido) {
  const r = await api.post("ofertas/guardarContenidoVersion", {
    ofertaContenido: ofertaContenido,
  });
  return r.data;
}

export async function cargarContratoVersion(id) {
  const r = await api.get("ofertas/cargarContratoVersion&ofertaId=" + id);
  return r.data.ofertaContrato;
}

export async function guardarContratoVersion(ofertaContrato) {
  const r = await api.post("ofertas/guardarContratoVersion", {
    ofertaContrato: ofertaContrato,
  });
  return r.data;
}

export async function cargarEstados() {
  const r = await api.post("ofertas/autocompletarEstados");
  return r.data;
}

export function crearVersion(id) {
  return api.get("ofertas/crearVersion&ofertaId=" + id).then((r) => r.data);
}

export function entregarVersion(id) {
  return api.get("ofertas/entregarVersion&ofertaId=" + id).then((r) => r.data);
}

export function visarVersion(id) {
  return api.get("ofertas/visarVersion&ofertaId=" + id).then((r) => r.data);
}

export function perderVersion(id) {
  return api.get("ofertas/perderVersion&ofertaId=" + id).then((r) => r.data);
}

export function enviarVersionPapelera(id) {
  return api.get("ofertas/enviarVersionPapelera&ofertaId=" + id).then((r) => r.data);
}

export function recuperarVersionDePapelera(id) {
  return api.get("ofertas/recuperarVersionDePapelera&ofertaId=" + id).then((r) => r.data);
}

export function tieneContrato(id) {
  return api.get("ofertas/tieneContrato&ofertaId=" + id).then((r) => r.data);
}

export function tieneUnidadNegocio(id) {
  return api.get("ofertas/tieneUnidadNegocio&ofertaBaseId=" + id).then((r) => r.data);
}

/**
 * Carga los módulos de una oferta incluyendo su contenido
 */
export async function guardarContenidoModulos(ofertaId, ofertaModulosContenido) {
  return await api.post("ofertas/guardarContenidoModulos", {
    ofertaId,
    ofertaModulosContenido,
  });
}

export function calcularValoracion(params) {
  return api.post("ofertas/calcularValoracion", params).then((response) => {
    var valoracion = response.data;

    return valoracion;
  });
}

export function activarOferta(ofertaId) {
  return api.post("ofertas/activarOferta", { ofertaId });
}
